/* eslint-env browser, jquery */
(function() {
    var timeout = {};

    window.App.onReady(function() {
        $('#append-address').on('click', function() {
            $(this).parents('.row').hide().end()
                .parents('form').find('[name=address]').parents('.row').show();
            return false;
        });
        $('#append-address').parents('form').find('[name=address_id]').on('change', function() {
            $(this).parents('form').find('[name=address]').html($(this).find('option:selected').text());
        });

        var $basket = $('.users-basket');
        $basket.find('.user-basket__delete').on('click', function() {
            var $this = $(this);
            $.ajax({
                url: '/users/outbasket/',
                dataType: 'json',
                type: 'post',
                data: {
                    catalog_id: $this.data('id')
                },
                cache: false,
                success: function(res) {
                    if (res.success == 1) {
                        $this.parents('tr:eq(0)').remove();
                        $('[change_auto_count=true]').html(res.count);
                        $('[change_auto_summ=true]').html(res.summ);
                        var $i = 0;
                        $basket.find('tr').each(function() {
                            if ($(this).hasClass('empty_border')) {
                                return;
                            };
                            $i++;
                            $(this).find('td:eq(0)').html($i);
                        });
                    } else {
                        alert(res.message);
                    }
                }
            });
            return false;
        });

        $('.users-basket .catalog--counter').each(function() {
            var id = $(this).data('id');
            var $counter = $(this).find('.catalog--counter__count');
            $(this).find('.catalog--counter__minus').on('click', function() {
                var value = $counter.html() - 0;

                value--;
                if (value <= 0) {
                    value = 1;
                }

                $counter.html(value);
                changeCount(id, value);

                return false;
            }).end().find('.catalog--counter__plus').on('click', function() {
                var value = $counter.html() - 0;

                value++;
                if (value >= 1000) {
                    value = 999;
                }

                $counter.html(value);
                changeCount(id, value);

                return false;
            });
        });
    });

    /**
     * @param {integer} id
     * @param {string} value
     */
    function changeCount(id, value) {
        if (timeout[id]) {
            clearTimeout(timeout[id]);
        }
        timeout[id] = setTimeout(function() {
            $.ajax({
                url: '/users/changecount/',
                dataType: 'json',
                type: 'post',
                data: {
                    catalog_id: id,
                    count: value
                },
                cache: false,
                success: function(res) {
                    if (res.success == 1) {
                        $('[change_auto_count=true]').html(res.count);
                        $('[change_auto_summ=true]').html(res.summ);
                        $('#pricewith_count_' + id).html(res.summ_catalog);
                    } else {
                        alert(res.message);
                    }
                }
            });
        }, 1000);
    }
})();
